export const APP_STRING = {
    VALIDATE_DOCUMENTS_TASK: 'VALIDATE DOCUMENTS',
    CASE_ASSIGNMENT_TASK: 'CASE ASSIGNMENT',
    VALIDATE_DOCUMENT_BUTTON: 'Validated',
    CASE_ASSIGNMENT_BUTTON: 'Forward to CJ',
    DRAFT_ENROLLED_ORDER: 'Draft Enrolled Order',
    SIGNED_ENROLLED_ORDER: 'Signed Enrolled Order',
    RECORD_OF_PROCEEDING_MOTION: 'Record Of Proceedings (Motion)',
    RULING: 'Ruling',
    FINAL_WRITTEN_ADOPTION_MOTION: 'Final Written Addresses Adoption (Motion)',
    DRAFT_DRAWNUP_ORDER: 'Draft DrawnUp Order',
    SIGNED_DRAWNUP_ORDER: 'Signed DrawnUp Order',
    RECORD_OF_PROCEEDING: 'Record Of Proceedings',
    JUDGEMENT: 'Judgement',
    FINAL_WRITTEN_ADOPTION: 'Final Written Addresses Adoption',
    COURT_PROCEEDINGS: 'Court Proceedings',
    ENROLLED_ORDER: 'Enrolled Order',
    RESERVED_FOR_JUDGEMENT: 'Reserved for Judgment',
    FINAL_WRITTEN_MOTION: 'Final Written Addresses (Motion)',
    FINAL_WRITTEN: 'Final Written Addresses',

    DOC_TYPE_CASE_ASSIGNMENT: 'case assignment',
    DOC_TYPE_CASE_READY_FOR_ASSIGNMENT: 'case ready for assignment',
    DOC_TYPE_READY_FOR_ASSIGNMENT: 'ready for assignment',
    DOC_TYPE_DOCUMENTS_VALIDATED: 'documents validated',
    DOC_TYPE_DOCUMENTS_VALIDATED_RECORD: 'validate case files record',



} as const;